import { AlertTriangle, LoaderCircle, MapPinOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MapNotice } from "./MapStyled";

export type MapFeedbackState = "tiles" | "error" | "tileError" | "categoryError" | "renderError" | "unavailable" | "empty" | null;
export const MapDataFeedback = ({ state, onRetry }: { state: MapFeedbackState; onRetry: () => void }) => {
  const { t } = useTranslation();
  if (!state) return null;
  const busy = state === "tiles";
  const error = state !== "tiles" && state !== "empty";
  const Icon = busy ? LoaderCircle : error ? AlertTriangle : MapPinOff;
  return <MapNotice role={error ? "alert" : "status"} aria-live={error ? "assertive" : "polite"} aria-atomic="true">
    <Icon size={20} aria-hidden="true" className={busy ? "map-spinner" : undefined} />
    <div><p>{t(`map.feedback.${state}`)}</p>{state === "empty" && <small>{t("map.feedback.explore")}</small>}</div>
    {error && <button type="button" onClick={onRetry}>{t("map.feedback.retry")}</button>}
  </MapNotice>;
};
